import { connect } from 'react-redux';
import { fetchTokenIfNeeded, fetchMethodIfNeeded, saveMethod } from 'common/ducks/billing';
import BraintreeForm from 'common/components/braintree_form';

const mapStateToProps = ({billing: {token, fetchingToken}}) => ({
  token,
  fetchingToken
})

export default connect(mapStateToProps, {
  fetchTokenIfNeeded,
  fetchMethodIfNeeded,
  saveMethod
}, null, { withRef: true})(BraintreeForm);



// WEBPACK FOOTER //
// ./common/containers/braintree_form.jsx